import { Injectable } from '@angular/core';

import * as Flickity from 'flickity';

@Injectable({
    providedIn: 'root',
})
export class SliderService {
    private instances: { [index: string]: Flickity } = {};

    public setInstance(id: string, slider: Flickity): void {
        this.instances[id] = slider;
    }

    public resizeInstance(id: string): void {
        this.instances[id].resize();
    }
}
